import React, { Fragment } from "react";
import { Link, useMatches } from "react-router-dom";
import { Box } from "@mui/material";
import { HomeIcon } from "@heroicons/react/24/outline";
import { useBreadcrumbs } from "@hooks/useBreadcrumbs/useBreadcrumbs";
import type { UIMatch } from "react-router-dom";
import { breadcrumbsStyle, separatorStyle } from "./styles";

const BreadLink = ({ to, children }: { to: string; children: React.ReactNode }) => <Link to={`${to}`}>{children}</Link>;

const Separator = () => (
  <Box component="span" sx={separatorStyle}>
    /
  </Box>
);

export const Breadcrumbs = () => {
  const matches: UIMatch<any, any>[] = useMatches();
  const { breadcrumbsMap } = useBreadcrumbs();

  return (
    <Box sx={breadcrumbsStyle}>
      {matches.map((match, index) => {
        if (index === 0) {
          return (
            <Link to={match.pathname} key={match.pathname} style={{ position: "relative", top: "3px" }}>
              <HomeIcon width="16" height="16" />
            </Link>
          );
        }

        if (!match.handle?.crumb) {
          return null;
        }

        const crumb = match.handle.crumb(match.params, breadcrumbsMap);

        if (typeof crumb === "string") {
          return (
            <Fragment key={match.pathname}>
              <Separator />
              <Link to={match.pathname}>{crumb}</Link>
            </Fragment>
          );
        }

        if (Array.isArray(crumb)) {
          return (
            <Box component="span" key={match.pathname}>
              {crumb.map(({ key, link, label }, index_) => (
                <Fragment key={link}>
                  <Separator />
                  {index_ === crumb.length - 1 ? (
                    <span>{breadcrumbsMap?.[key] ?? label}</span>
                  ) : (
                    <BreadLink to={link} key={link}>
                      {breadcrumbsMap?.[key] ?? label}
                    </BreadLink>
                  )}
                </Fragment>
              ))}
            </Box>
          );
        }

        return null;
      })}
    </Box>
  );
};
